import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { makeStyles,withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import { Link } from 'react-router-dom';
import { red,lightBlue ,indigo} from "@material-ui/core/colors";
import moment from "moment";
import { useSelector } from "react-redux";
import billingHistoryService from "../../service/e_billing-history-service";
import { store } from "../../../../helpers/store";
import { useEffect,useState } from "react";
import { Fragment } from 'react';
import { routePaths } from '../../../config/route-paths';
import { Chip, CircularProgress } from "@material-ui/core";
import { Grid, Hidden, Typography } from '@material-ui/core';
import { cssuseStyles } from '../../e_billing-style';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from "react-i18next";
import { payment } from '../../e_payment-details/services/e_payment-receipt-service';


export const CustomiseChip = withStyles(theme => ({
    root: {
      fontSize: theme.typography.pxToRem(11),
      borderRadius:'3px !important',
      padding:'0% !important'
    },
  }))(Chip);

const useStyles = makeStyles((theme) => ({
    root: {
      width: '50%',
    },
    tabelcell:{
        padding:"5px"
    },
    container: {
        marginBottom:10,
    },
    smpadding:{
        padding:"8px !important"
    },
    rowborder:{
      borderWidth:"1px",
      borderColor:theme.palette.eLight?.base,
      borderStyle:'solid',
      "& .MuiTableCell-root": {
        padding:"4px 16px" + "!important",
        borderTopLeftRadius: "4px",
        borderBottom: 0
    }},
    rowborder1: {
      borderWidth:"1px",
      borderColor:theme.palette.eLight?.base,
      borderStyle:'solid',
      "& .MuiTableCell-root": {
        borderTopLeftRadius: "4px",
        borderBottom: 0
    }
    },
    smrowborder:{
        borderWidth:"0px",
        borderColor:theme.palette.eLight?.base,

        "& .MuiTableCell-root": {
          padding:"4px 4px" + "!important",
          borderTopLeftRadius: "4px",
          borderBottom: 0
      }
    },
    rowpadding:{
        padding:"1% 5% !important",
        borderBottom: 0,
        [theme.breakpoints.down("md")]: {
            fontSize:'0.750rem'
          },
    },
    total:{
        color:theme.palette.eTertiary?.base,
        fontWeight:"bold"

    },
    expansiontable:{
        borderWidth:"1px",
        borderColor:theme.palette.whiteColor.main ,
        borderStyle:'solid'
    },
    expansiontablefirstrow:{
        margin:"0px",
        borderWidth:"2px",
    },
    marginbetweenrows:{
        margin:"10px",
        borderWidth:"0px",
    },
    chargeamount:{
        color:theme.palette.eTertiary?.base + " !important",
        fontWeight:"bold"
    },
    ChargeColor:{
        color:theme.palette.eTertiary?.base + " !important",
        fontWeight:"bold"
    },
    chargetitle:{
        color:theme.palette.ePrimary?.base + " !important",
        
    },

    amoutColorRed: {
        background:theme.palette.eTertiary?.base+" !important",
        color:theme.palette.eWhite?.base+" !important"
    },
    chipColorRed: {
        background: theme.palette.eTertiary?.base+" !important",
        color:theme.palette.eWhite?.base+" !important"
    },
    chipColorBlue:{
        background:theme.palette.eSecondary?.base+" !important",
        color:theme.palette.eWhite?.base+" !important"
    },
    borderMainRow: {
        border: "1px solid " + theme.palette.eLight?.base,
       
    },
    mobileborder:{
        "& .MuiTypography-body1":{
            fontSize:"0.75rem",
            borderTop:"0px solid" + theme.palette.eLight?.base,
            borderBottom:"1px solid" + theme.palette.eLight?.base
          }
    },
    paddingDate: {
        color: theme.palette.tertiary.main 
    },
    topElement: {
        verticalAlign: "top !important",
        padding: "2% 0% !important",
    },
      paddingContent: {
        padding: "0% 1% 2% 1% !important",
        width: "100%",
    },
    quaternaryColor: {
        color: theme.palette.quaternary.main,
      },
    borderNone: {
        border: "none !important",
        padding: "1% !important",
        minWidth: "100px !important",
        verticalAlign: "initial !important",
      },
    linkpay: {
        color: theme.palette.ePrimary?.base,
        textDecorationLine: 'underline',
        fontSize:"12px",
       "&:hover":{
          color: theme.palette.ePrimary?.hover,
        },
        
      },
      width20:{
        width:"20%"
    },
    width30:{
        width:"30%"
    },
    padding3:{
        padding:"0%"
    },
    marginLeft:{
        marginLeft:"10%"
    },
    pd6:{
        borderWidth:"1px",
        borderColor:theme.palette.eLight?.base,
        borderStyle:'solid',
        "& .MuiTableCell-root": {
          borderTopLeftRadius: "4px",
          borderBottom: 0
      }
    },
    pd12:{
        paddingBottom:"12% !important"
    },
    loader:{
        display: 'table-cell',
        border: '1px solid transparent',
        margin: '0px auto',
        alignSelf: 'inherit',
        position: 'relative',
        left: '50%'
    }
    }));
    
function Tablesrows({row,tabName, collapseRows:changeInParent}) {
    const useStyleClasses = useStyles();
    const classes = cssuseStyles();
    const [open, setOpen] = React.useState(false);
    const [slabRate,setSlabRate] = useState([])
    const [load,setLoad] = useState(false)
    const [showArrow,setShowArrow]=useState(false)
    const [isLastDayOfMonth, setIsLastDayOfMonth] = useState(false)
    // let billHistoriLabels = useSelector(
    //     (state) => state?.labels?.data?.getLabels?.E_BILLS_CHARGES_AND_PAYMENTS
    // );
    const { t: billHistoriLabels, ready: billHistoriLabelsReady } = useTranslation("label-E_BILLS_CHARGES_AND_PAYMENTS");
    let contentTitle = `${useStyleClasses.ChargeColor} ${useStyleClasses.borderNone}`;
    const [linkData,setLinkData] = useState([]);
    const primaryIdentifier = useSelector((state) =>state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER);
    const accountId = store.getState().meterDetails[primaryIdentifier];
    const primarylanguageCode = store.getState()?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE;
    let prepaidChargePaymentLabels = useSelector(
        (state) => state?.labels?.data?.getLabels?.PREPAID_CHARGES_AND_PAYMENTS
      );
    const [preBillFields, setBillsFields] = useState([
        { key: "", isAmount: false, display: false },
        { key: "E_BILL_FIELD_ENERGY_CHARGE", isAmount: true, display: true },
        { key: "E_BILL_FIELD_DEMAND_CHARGE", isAmount: true, display: true },
        { key: "E_BILL_FIELD_ADDITIONAL_LOAD_CHARGE", isAmount: true, display: true },
        { key: "E_BILL_FIELD_METERRENT", isAmount: true, display: true },
        { key: "", isAmount: true, display: true },
        { key: "E_BILL_FIELD_VAT", isAmount: true, display: true },
        { key: "REBATE1", isAmount: true, display: true },
    ]);
    const [postBillFileds, setPostBillsFields] = useState([
        { key: "", isAmount: false, display: false },
        { key: "E_BILL_FIELD_APP_CHARGE", isAmount: true, display: true },
        { key: "E_BILL_FIELD_CONTINGENCY_CHARGE", isAmount: true, display: true },
        { key: "E_BILL_FIELD_NESCO_SUPPLIED_MATERIALS", isAmount: true, display: true },
        { key: "E_BILL_FIELD_SECURITY_DEPOSITE", isAmount: true, display: true },
        { key: "E_BILL_FIELD_VAT", isAmount: true, display: true },
        { key: "E_BILL_FIELD_TOTAL_AMOUNT", isAmount: true, display: false },
    ]);
    let dateFormat = useSelector((state)=>state?.parametersWidgets?.ParameterLookup?.E_DATE_MONTH_YEAR_FORMAT)
    const [currency,setCurrency] = useState(row.currency)
    const EDGE_CURRENCY_SYMBOL= "BDT";
    const PREPAID_BILL_LABEL= "Prepaid Bill";
    const POSTPAID_BILL_LABEL= "Postpaid Bill";
    let currencyCode = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.E_CURRENCY_CODE);

    function checkFields(data) {
        let demandChargePresent = false;
        let meterRentPresent = false;
        let additionalCharge=false;
        // Loop through the custom2 fields to check for DEMAND_CHARGE,ADDITIONAL_LOAD_CHARGE and METERRENT
        for (let key in data.custom2) {
            if (data.custom2[key].name === 'DEMAND_CHARGE' && data.custom2[key].value!="") {
                demandChargePresent = true;
            }
            if (data.custom2[key].name === 'METERRENT' && data.custom2[key].value!="") {
                meterRentPresent = true;
            }
            if (data.custom2[key].name === 'ADDITIONAL_LOAD_CHARGE' && data.custom2[key].value!="") {
                additionalCharge = true;
            }
        }
        return {
            demandChargePresent,
            meterRentPresent,
            additionalCharge
        };
    }

    useEffect(() => {
        if(row?.currency) {
            setCurrency(row.currency && row.currency==EDGE_CURRENCY_SYMBOL?currencyCode:row.currency);
        }
    }, [row?.currency, currencyCode]);

    useEffect(()=>{
        const dateToCheck = moment(row['date']);
        setIsLastDayOfMonth(dateToCheck.isSame(dateToCheck.clone().endOf('month'), 'day'));
    },[row])

    useEffect(()=>{
        console.log("Use effect-1")
        if(isLastDayOfMonth){
            setShowArrow(true)
            //setShowArrow(false)
        }else{
            //show accordian if any of METERENT,DEMAND_CHARGE,ADDITIONAL_LOAD_CHARGE is there
            const resultObj = checkFields(row);
            let showAccordian= Object.values(resultObj).some(value => value === true);
            setShowArrow(showAccordian)
            //setDemandmeter(true)
        } 
    },[row,isLastDayOfMonth])

    useEffect(() => {
        setOpen(false)
    }, [changeInParent])
    useEffect(()=>{
        if(open==true && row?.txnId){
            setLoad(true)
            payment.slabRates(row?.txnId?.toString())
            .then(response=>{
                setLoad(false)
                let splitText ='Summary of stepped charges'
                let test =response.data?.getSlabRates?.slabRates.map(e=>e['descOnBill'])
                let count =0
                for (const element of test) {
                    if (element ==splitText) {
                      count+=1
                    }
                  }

                
                if(count==2){
                    let index = response.data?.getSlabRates?.slabRates?.findIndex(e=>e['descOnBill']==splitText)
                    let newSlab = response.data?.getSlabRates?.slabRates.slice(index+1)
                    
                    setSlabRate(newSlab)
                }
                else{
                    setSlabRate(response.data?.getSlabRates?.slabRates)
                }
            }).catch(e=>{
                setLoad(false)
                setSlabRate([])
            })
        }
    },[row,open])

    const handleClick=()=>{
        if(showArrow){
            setOpen(!open)
        }
    }

    return (
        <>
        <Hidden xsDown>
        { tabName === "charges" && (row.label === PREPAID_BILL_LABEL || row.label === POSTPAID_BILL_LABEL) && (
            <React.Fragment>
                <TableRow className={useStyleClasses.rowborder}  onClick={handleClick}>
                    <TableCell className={useStyleClasses.width30} align="left"  >
                        {moment(row.date).format(dateFormat)}
                    </TableCell>
                    <TableCell className={useStyleClasses.width30}>
                    <span className={useStyleClasses.chargetitle}>
                        {
                            row.label === PREPAID_BILL_LABEL ? billHistoriLabels("E_PREPAID_BILL_ROW_TITLE") : billHistoriLabels("E_POSTPAID_BILL_ROW_TITLE")
                        }
                    </span>
                    </TableCell>
                    <TableCell  align="left" className={`${useStyleClasses.chargeamount} ${useStyleClasses.width20}`}>
                         {Number(row.consumption)}
                    </TableCell>
                    <TableCell  align="left" className={`${useStyleClasses.chargeamount} ${useStyleClasses.width20}`}>
                         {row.amount}
                    </TableCell>
                    <TableCell  align='right' className={useStyleClasses.width20}>
                    <IconButton style={{visibility: showArrow? 'visible':'hidden'}}  aria-label="expand row" size="small" onClick={handleClick}>
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </TableCell>
                </TableRow>
                <TableRow className={`${useStyleClasses.pd6} ${classes.paddingrow}`} >
                {open ? <> <TableCell className={useStyleClasses.width20}> </TableCell>
                    {load && isLastDayOfMonth && <CircularProgress size={30} />}
                    <TableCell colSpan={3}>
                        {slabRate.length >0 && load==false && 
                           slabRate.map(each=>{
                                return (
                                    <TableRow >
                                        <TableCell>{each?.descOnBill}</TableCell>
                                        <TableCell>{currency} {each?.calAmount}</TableCell>
                                    </TableRow>
                                )
                           }) 
                        }
                        {
                           !isLastDayOfMonth && row.label === PREPAID_BILL_LABEL && preBillFields?.map((obj, index) => (
                                row?.custom2 && row?.custom2["field" + index]?.value && obj?.key && obj?.display &&
                                <TableRow >
                                    <TableCell >{obj?.key=="REBATE1"?billHistoriLabels('REBATE1'):billHistoriLabels(obj?.key)}</TableCell>
                                    <TableCell >
                                        {obj?.isAmount && `${currency} `}
                                        {row.custom2["field" + index].value}
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                        {/* {
                            row.label === POSTPAID_BILL_LABEL && postBillFileds?.map((obj, index) => (
                                row?.custom2 && row?.custom2["field" + index]?.value && obj?.key && obj?.display &&
                                <TableRow >
                                   <TableCell >{billHistoriLabels(obj?.key)}</TableCell>
                                    <TableCell >
                                        {obj?.isAmount && `${currency} `}
                                        {row.custom2["field" + index].value}
                                    </TableCell>
                                </TableRow>
                            )) 
                        } */}
                        {/* <TableRow >
                        <TableCell className={useStyleClasses.chargeamount}>{billHistoriLabels("E_CHARGE_TOTAL")}1111</TableCell>
                            <TableCell className={useStyleClasses.chargeamount}>{currency} {row.amount}</TableCell>
                        </TableRow> */}
                    </TableCell>

                </>
                :null}
                </TableRow>
            <hr className={useStyleClasses.marginbetweenrows}/>
    </React.Fragment>)
    }
    { tabName === "bills" && row.label === "Bill" && (
            <React.Fragment>
                <TableRow className={useStyleClasses.rowborder}  onClick={() => setOpen(!open)}>
                <TableCell  align="left" className={`${useStyleClasses.rowpadding} ${useStyleClasses.width30}`} >
                    {moment(row.date).format(dateFormat)}
                </TableCell>
                <TableCell className={useStyleClasses.rowpadding}>
                    <CustomiseChip
                            size="small"
                            label={
                                row?.custom?.field1?.name === "billPaymentStatus" && (
                                <b> {row?.custom?.field1?.value}</b>
                                )
                            }
                            className={
                                row?.custom?.field1?.name === "billPaymentStatus" &&
                                row?.custom?.field1?.value === "UNPAID"
                                ? `${useStyleClasses.amoutColorRed} ${useStyleClasses.chipColorRed}`
                                : useStyleClasses.chipColorBlue
                            }
                            />
                 
                </TableCell>
                <TableCell className={`${useStyleClasses.chargeamount} ${useStyleClasses.rowpadding} ${useStyleClasses.width20}`} align="left" >
                    {row.amount}
                </TableCell>
                <TableCell align='right' className={useStyleClasses.rowpadding}>
                <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton> 
                </TableCell>
            </TableRow>
            <TableRow className={`${classes.paddingrow} ${useStyleClasses.rowborder1}`}>
            {open ? <> <TableCell className={useStyleClasses.width30}> </TableCell>
                        <TableCell colSpan={3}>
                        {row?.detail?.map((item,i) => {
                            return (<Fragment>
                                        <TableRow >
                                            <TableCell>{item?.label}</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell>{item?.currency} {item?.amount}</TableCell>
                                        </TableRow>
                                </Fragment>
                            )
                        })}
                      
                            <TableRow >
                            <TableCell className={useStyleClasses.total}>{billHistoriLabels("E_CHARGE_FOR_TABLE")}</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell className={useStyleClasses.total}>{row?.currency} {row?.amount}</TableCell>
                            </TableRow>
                            <TableRow className={useStyleClasses.expansiontable}>
                            <TableCell colSpan={2}>
                                        <Link
                                        variant="caption"
                                            to={{
                                            pathname: `${routePaths.BILL_DETAILS}/${accountId}/${row.billId}`,
                                            data: {
                                                billId: row.billId,
                                                accountID: accountId,
                                            },
                                            }}
                                            className={useStyleClasses.linkpay}
                                        >
                                            <b>{billHistoriLabels("E_VIEW_BILL_DETAILS")}</b>
                                        </Link>
                                    </TableCell>
                                </TableRow>
                        </TableCell>
                </>
                :null}
            </TableRow>
            <hr className={useStyleClasses.marginbetweenrows}/>
    </React.Fragment>)
    }
    </Hidden>

    <Hidden smUp>
    { tabName === "bills" && row.label === "Bill" && (
        <React.Fragment>
        <TableRow onClick={()=>{setOpen(!open)}} className={useStyleClasses.mobileborder}>
            <Typography
              align="left"
              className={useStyleClasses.smpadding}
            >
                <Grid container direction="row">
                    <Grid item xs={4} className={useStyleClasses.padding3}>
                        {moment(row.date.slice(0, 10)).format(dateFormat)}
                    </Grid>
                    <Grid xs={3}  className={useStyleClasses.chargetitle}>
                    <CustomiseChip
                            size="small"
                            label={
                               
                                row?.custom?.field1?.name === "billPaymentStatus" && (
                                <b> {row?.custom?.field1?.value} </b>
                                )
                            }
                            className={
                                row?.custom?.field1?.name === "billPaymentStatus" &&
                                row?.custom?.field1?.value === "UNPAID"
                                ? `${useStyleClasses.amoutColorRed} ${useStyleClasses.chipColorRed}`
                                : useStyleClasses.chipColorBlue
                            }
                            />
                    </Grid>
                    <Grid item xs={4} container justify='center'  className={useStyleClasses.chargeamount}>
                         {row.amount}
                    </Grid>
                    <Grid style={{visibility: showArrow? 'visible':'hidden'}} container justify='center' item xs={1}>
                        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Grid>
                </Grid>
            </Typography>
          <TableRow className={useStyleClasses.smrowborder}>
           
            <TableCell align="left" className={useStyleClasses.paddingContent}>
              
              <Collapse in={open} timeout="auto">
                <Table aria-label="simple table">
                  <TableBody>
                   
                        {row?.detail?.map((item,i) => {
                            return (<Fragment>
                                        <TableRow>
                                            <TableCell align="left" className={useStyleClasses.borderNone}>{item?.label}</TableCell>
                                            <TableCell align="left" className={useStyleClasses.borderNone}>{item?.currency} {item?.amount}</TableCell>
                                        </TableRow>
                                </Fragment>
                            )
                        })}
                            <TableRow>
                            <TableCell align="left" className={contentTitle}>{billHistoriLabels("E_CHARGE_TOTAL")}</TableCell>
                                <TableCell className={contentTitle}>{currency} {row.amount}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colspan={3}>
                                    <Link
                                    variant="caption"
                                        to={{
                                        pathname: `${routePaths.BILL_DETAILS}/${accountId}/${row.billId}`,
                                        data: {
                                            billId: row.billId,
                                            accountID: accountId,
                                        },
                                        }}
                                        className={useStyleClasses.linkpay}
                                    >
                                        <b>{billHistoriLabels("E_VIEW_BILL_DETAILS")}</b>
                                    </Link>
                                </TableCell>
                            </TableRow>
                  </TableBody>
                </Table>
              </Collapse>
            </TableCell>
          </TableRow>
        </TableRow>
        </React.Fragment>
    )}
    {tabName === "charges" && (row.label === PREPAID_BILL_LABEL || row.label === POSTPAID_BILL_LABEL) && (
        <React.Fragment>
        <TableRow onClick={handleClick} className={useStyleClasses.mobileborder}>
            <Typography
              align="left"
              className={useStyleClasses.smpadding}
            >
                <Grid container direction="row">
                    <Grid item xs={3} className={useStyleClasses.padding3}>
                        {moment(row.date.slice(0, 10)).format(dateFormat)}
                    </Grid>
                    <Grid item xs={3} >                   
                    <span className={useStyleClasses.chargetitle}>
                        {
                            row.label === PREPAID_BILL_LABEL ? billHistoriLabels("E_PREPAID_BILL_ROW_TITLE") : billHistoriLabels("E_POSTPAID_BILL_ROW_TITLE")
                        }
                    </span>
                    </Grid>
                    <Grid item xs={2} className={useStyleClasses.padding3}>
                    {Number(row.consumption)}
                    </Grid>
                    <Grid container justify='center' item xs={3}  className={useStyleClasses.chargeamount}>
                       {row.amount}
                    </Grid>
                    <Grid style={{visibility: showArrow? 'visible':'hidden'}} item xs={1}>
                        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </Grid>
                </Grid>
            </Typography>
          <TableRow className={useStyleClasses.smrowborder}>
           {open ? <>  {load && isLastDayOfMonth && <Grid container className={useStyleClasses.loader} >

                        <div>
                            {<CircularProgress size={30} />}
                        </div>
                        </Grid>}
                    <Grid container>
                        
                    { slabRate.length>0 && load==false &&
                            row.label === PREPAID_BILL_LABEL && slabRate?.map((obj, index) => (
                                <Grid direction='row' container >
                                    <Grid xs={8} item className={`${useStyleClasses.rowpadding}`}>{obj.descOnBill}</Grid>
                                    <Grid xs={4} item className={`${useStyleClasses.borderNone} ${useStyleClasses.rowpadding}`}>{currency} {obj.calAmount}</Grid>
                                </Grid>
                            ))
                        }
                        {
                           !isLastDayOfMonth &&  row.label === PREPAID_BILL_LABEL && preBillFields?.map((obj, index) => (
                                row?.custom2 && row?.custom2["field" + index]?.value && obj?.key && obj?.display &&
                                <Grid direction='row' container>
                                    <Grid xs={8} item className={`${useStyleClasses.rowpadding}`}>{obj?.key=="REBATE1"?billHistoriLabels('REBATE1')+ " ":billHistoriLabels(obj?.key)+ " "}</Grid>
                                    <Grid xs={4} item className={`${useStyleClasses.borderNone} ${useStyleClasses.rowpadding}`}>
                                        {obj?.isAmount && `${currency} `}
                                        {row.custom2["field" + index].value}    
                                    </Grid>
                                </Grid>
                            ))
                        }
                       {/*  {
                            row.label === POSTPAID_BILL_LABEL && postBillFileds?.map((obj, index) => (
                                row?.custom2 && row?.custom2["field" + index]?.value && obj?.key && obj?.display &&
                                <Grid direction='row' container>
                                    <Grid xs={5} item className={`${useStyleClasses.rowpadding}`}>{billHistoriLabels[obj?.key]}</Grid>
                                    <Grid xs={7} item className={`${useStyleClasses.borderNone} ${useStyleClasses.rowpadding}`}>
                                        {obj?.isAmount && `${currency} `}
                                        {row.custom2["field" + index].value}
                                    </Grid>
                                </Grid>
                            )) 
                        }
                        <Grid direction='row' container className={classes.fontContent}>
                        <Grid xs={5} item  className={`${useStyleClasses.rowpadding} ${useStyleClasses.chargeamount}`}>{billHistoriLabels("E_CHARGE_TOTAL")}</Grid>
                            <Grid xs={7} item className={`${useStyleClasses.borderNone} ${useStyleClasses.rowpadding} ${useStyleClasses.chargeamount}`}>{currency} {row.amount}</Grid>
                        </Grid> */}
                        </Grid>
                </>
                :null}
               
          </TableRow>
        </TableRow>
        </React.Fragment>
    )}
    </Hidden>
    </>
    )  
}
export default Tablesrows